import { render, staticRenderFns } from "./BrowserVersion.vue?vue&type=template&id=a0b2f96c"
import script from "./BrowserVersion.vue?vue&type=script&lang=js"
export * from "./BrowserVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports